import type { TextProps } from '@react-pdf/renderer';

type HyphenationCallback = NonNullable<TextProps['hyphenationCallback']>;

export const noHyphenation: HyphenationCallback = (word: string) => {
  return [word];
};
